import type { BorderRadius, ColorToken, Spacing } from './types';

export const COLOR_MAP: Record<ColorToken, string> = {
  'blue-darkest': 'blue.darkest',
  'blue-dark': 'blue.dark',
  blue: 'blue.primary',
  'blue-light': 'blue.light',
  'blue-lighter': 'blue.lighter',
  'blue-lighter-2': 'blue.lighter2',
  'blue-extra-light': 'blue.extraLight',
  'blue-lightest': 'blue.lightest',

  'green-darkest': 'green.darkest',
  'green-dark': 'green.dark',
  green: 'green.primary',
  'green-light': 'green.light',
  'green-lighter': 'green.lighter',
  'green-lighter-2': 'green.lighter2',
  'green-lightest': 'green.lightest',
  'green-extra-light': 'green.extraLight',

  'yellow-darkest': 'yellow.darkest',
  'yellow-dark': 'yellow.dark',
  yellow: 'yellow.primary',
  'yellow-light': 'yellow.light',
  'yellow-lighter': 'yellow.lighter',
  'yellow-lighter-2': 'yellow.lighter2',
  'yellow-lightest': 'yellow.lightest',
  'yellow-extra-light': 'yellow.extraLight',

  'red-darker': 'red.darker',
  'red-dark': 'red.dark',
  red: 'red.primary',
  'red-light': 'red.light',
  'red-lighter': 'red.lighter',
  'red-lighter-2': 'red.lighter2',
  'red-lightest': 'red.lightest',
  'red-extra-light': 'red.extraLight',

  'brown-darkest': 'brown.darkest',
  'brown-dark': 'brown.dark',
  brown: 'brown.primary',
  'brown-light': 'brown.light',
  'brown-lighter': 'brown.lighter',
  'brown-lighter-2': 'brown.lighter2',
  'brown-lighter-3': 'brown.lightest',
  'brown-lighter-4': 'brown.extraLight',
  'brown-lightest': 'brown.lightest',
  'brown-extra-light': 'brown.extraLight',

  'neutral-darkest': 'neutral.darkest',
  'neutral-darker-2': 'neutral.darker2',
  'neutral-darker': 'neutral.darker',
  'neutral-dark': 'neutral.dark',
  'neutral-extra-dark': 'neutral.extraDark',
  'neutral-light': 'neutral.light',
  'neutral-lighter': 'neutral.lighter',
  'neutral-lighter-2': 'neutral.lighter2',
  'neutral-lightest': 'neutral.lightest',

  'nw-green': 'green.primary',
  'nw-logo-green': 'logo.primary',
  'nw-logo-green-dark': 'logo.dark',
  'nw-logo-green-light': 'logo.light',

  'teal': 'blue.primary',
  'teal-light': 'blue.lightest',
  transparent: 'transparent',
  white: 'neutral.white',
  bone: 'neutral.bone',
};

export const BORDER_RADIUS_MAP: Record<BorderRadius, string> = {
  0: '0',
  1: '0.125rem',
  2: '0.25rem',
};

export const SPACING_MAP: Record<Spacing, number | undefined> = {
  '0': 0,
  '1': 1,
  '2': 2,
  '3': 4,
  '3-half': 6,
  '4': 8,
  '5': 16,
};

export const ALIGN_Y_MAP: Record<
  'top' | 'center' | 'bottom',
  'flex-start' | 'center' | 'flex-end'
> = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
};
